import { render, staticRenderFns } from "./documents-preview-item.vue?vue&type=template&id=312b55ef&scoped=true&"
import script from "./documents-preview-item.vue?vue&type=script&lang=ts&"
export * from "./documents-preview-item.vue?vue&type=script&lang=ts&"
import style0 from "./documents-preview-item.vue?vue&type=style&index=0&id=312b55ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312b55ef",
  null
  
)

export default component.exports